export const environment = {
    production: false,
    baseURL: 'https://planner-api-rc.advocate-digital.com',
    auth0: {
        domain: 'dev-auw2e7n8zwxm06j5.eu.auth0.com',
        clientId: 'UE2NCJINUogoLpQuexHT0TpaY4wKYMwI',
        redirectUri: globalThis.location.origin + '/callback',
        audience: 'https://media-planner-service-66842863048.us-central1.run.app/api'
    }
};
